<template>
  <div class="ion-text-right">
    <ion-label class="u-color-primary">{{ prefix }}</ion-label>
    <ion-item lines="none" class="ion-margin-vertical">
      <ion-datetime
        placeholder="Bitte wählen"
        v-model="date"
        displayFormat="MMMM YYYY"
        :monthNames="[
          'Jänner',
          'Februar',
          'März',
          'April',
          'Mai',
          'Juni',
          'Juli',
          'August',
          'September',
          'Oktober',
          'November',
          'Dezember',
        ]"
        pickerFormat="MMMM YYYY"
        cancelText="Abbrechen"
        doneText="Fertig"
        slot="end"
        :max="new Date().toISOString()"
        @ionCancel="date = ''"></ion-datetime>
    </ion-item>
    <next-question-button
      @click="
        $emit('done', {
          value:
            date === ''
              ? 'Keine Angabe'
              : DateFormatter.formatDate(new Date(date), 'MMMM YYYY'),
          id: question.id,
          date: date ? date.substring(0, 8) + '01' : '',
        })
      " />
  </div>
</template>

<script>
import NextQuestionButton from "./NextQuestionButton";
import { IonItem, IonLabel, IonDatetime } from "@ionic/vue";
import { DateFormatter } from "@arag/utils/basics/date";

export default {
  emits: ["done"],
  components: {
    NextQuestionButton,
    IonItem,
    IonLabel,
    IonDatetime,
  },
  props: {
    question: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      date: "",
      DateFormatter: DateFormatter,
    };
  },
  computed: {
    prefix() {
      let result = "Am";
      if (this.question.prefix) {
        result = this.question.prefix;
      }
      return result;
    },
  },
};
</script>

<style></style>
